import { Heading, Text } from '@restworld/ui-ds-base';
import { FlexCol } from './header';
import { ProposedJobPositionSetting } from './proposed-job-position-setting';
import { UserNotificationPublicShowcaseSwitch } from './user-notification-public-showcase-switch';
import { useTranslation } from 'next-i18next';
import { useAtomValue } from 'jotai';
import { workerAtom } from '../../global-state.worker-data';
export const UserNotificationTab = () => {
  const { t } = useTranslation('user-settings');
  const subTitle = t('notification_tab_subheader');
  return (
    <div className="flex lg:flex-row flex-col lg:justify-between lg:items-start items-start justify-start w-full gap-8">
      <FlexCol className="gap-2 items-start justify-start lg:w-[457px] w-full">
        <Heading>{t('notification_tab_header')}</Heading>
        <Heading size={5} color="muted-foreground" weight="normal" className="hidden lg:block">
          {subTitle}
        </Heading>
        <div className="lg:hidden block w-full">
          <Text>{subTitle}</Text>
        </div>
      </FlexCol>
      <FlexCol className="lg:gap-8 gap-6 items-start justify-start lg:w-[500px] w-full">
        <ProposedJobPositionSetting />
        {/* Switch per notifiche nuovi locali pubblici */}
        <UserNotificationPublicShowcaseSwitch
          value={useAtomValue(workerAtom)?.data?.new_public_showcase_notification_enabled ?? false}
        />
      </FlexCol>
    </div>
  );
};
